/**Реализация логики для пересылки запросов к серверному или фейковому api возврата ответа*/
// eslint-disable-next-line no-unused-vars
export async function request(method='test',context={}, api_config={}) {
//В режиме dev используем фейковый api
if(api_config.mode === 'dev'){
 let {request} = await import('@/fake_api');
 return request(method,context, api_config);
}
//Если не dev используем реальный запрос к серверу
 else {
        let response = await fetch(api_config.url+method, context);
        return response.json();
    }
  }

